import { Button, Card, EmptyState, Text } from '@ui/themed';
import { t } from 'i18next';
import { Upsell } from '../../../components/upsell';
import { useHandlers, useSite } from '../../../context/page-context';
import { trackUpgradeClicked } from '../../../lib/mixpanel';

const THEMES_LEARN_MORE_URL = 'https://docs.sparklayer.io/dashboard-configurations#j6s7E';

export function ThemesEmptyState({
  planHasThemes,
  onCreate,
}: {
  planHasThemes: boolean;
  onCreate: () => void;
}) {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  const featureItems = [
    {
      key: 'emails',
      title: t('features:themes.pages.themes_list_page.empty.features.emails.title'),
      description: t('features:themes.pages.themes_list_page.empty.features.emails.description'),
    },
    {
      key: 'pdfs',
      title: t('features:themes.pages.themes_list_page.empty.features.pdfs.title'),
      description: t('features:themes.pages.themes_list_page.empty.features.pdfs.description'),
    },
  ];

  if (!planHasThemes) {
    return (
      <Card>
        <Upsell
          title={t('features:themes.pages.themes_list_page.empty.title')}
          subtitle={t('features:themes.pages.themes_list_page.empty.subtitle')}
          imageType="themes"
          plans={['v2_pro']}
          onClickUpgrade={() => {
            trackUpgradeClicked(site, 'Themes');
            navigationHandler.navigateById('plan');
          }}
          onClickLearn={() => window.open(THEMES_LEARN_MORE_URL, '_blank', 'noopener,noreferrer')}
          details={{
            foreword: t('features:themes.pages.themes_list_page.empty.intro'),
            use_cases: featureItems,
            afterword: t('features:themes.pages.themes_list_page.empty.note'),
          }}
        />
      </Card>
    );
  }

  return (
    <Card>
      <EmptyState
        title={t('features:themes.pages.themes_list_page.empty.title')}
        subtitle={t('features:themes.pages.themes_list_page.empty.subtitle')}
        imageType="themes"
      >
        <div className="flex w-full max-w-lg flex-col items-center gap-6">
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Button icon="plusCircle" onClick={onCreate}>
              {t('features:themes.pages.themes_list_page.create_button')}
            </Button>
            <Button
              variant="secondary"
              icon="externalLink"
              onClick={() => window.open(THEMES_LEARN_MORE_URL, '_blank', 'noopener,noreferrer')}
            >
              {t('features:themes.pages.themes_list_page.empty.learn_button')}
            </Button>
          </div>
          <div className="text-center">
            <Text variant="secondary">
              {t('features:themes.pages.themes_list_page.empty.note')}
            </Text>
          </div>
        </div>
      </EmptyState>
    </Card>
  );
}
